import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedBackground from './AnimatedBackground';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <AnimatedBackground />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

export default Layout;
